import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resend-countdown"
//
// Disables a "Resend code" submit button for a throttle window and shows a live countdown, so a
// user who clicks too soon sees how long to wait instead of a bare "please wait" flash. The window
// is seeded from the server (seconds-value) but the tick is client-side and deliberately
// approximate — it is not re-synced to the server clock.
export default class extends Controller {
  static values = { seconds: Number };

  connect() {
    this.button = this.element.querySelector("input[type='submit'], button[type='submit']");
    if (!this.button) return;

    this.defaultLabel = this.label();
    this.remaining = this.secondsValue;
    if (this.remaining > 0) {
      this.render();
      this.timer = setInterval(() => this.tick(), 1000);
    }
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  tick() {
    this.remaining -= 1;
    if (this.remaining > 0) {
      this.render();
    } else {
      this.reset();
    }
  }

  render() {
    this.button.disabled = true;
    const template = window.I18n["views.two_factor.challenge.resend_in"];
    this.setLabel(template.replace("%{seconds}", this.remaining));
  }

  reset() {
    if (this.timer) clearInterval(this.timer);
    this.button.disabled = false;
    this.setLabel(this.defaultLabel);
  }

  label() {
    return this.button.tagName === "INPUT" ? this.button.value : this.button.textContent;
  }

  setLabel(text) {
    if (this.button.tagName === "INPUT") {
      this.button.value = text;
    } else {
      this.button.textContent = text;
    }
  }
}
